// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"cfe67d1e","72":"293b49b4","87":"dc6f018c","121":"ef5c8290","163":"ed0801dd","251":"1a4ffae7","444":"eca3bf97","460":"e92cc32f","606":"61f86390","693":"9243f72e","767":"1eed06df"}[chunkId] + ".chunk.js";
};